import { createContext } from 'react';

import type { IGlobalStateContext } from './types';

export const GlobalStateContext = createContext<IGlobalStateContext>(null!);
